import * as tslib_1 from "tslib";
import { ShaderChunkBase } from "./ShaderChunkBase";
/**
 * EffectFogChunk provides a method to add distance-based fog to a material.
 */
var EffectFogChunk = (function (_super) {
    tslib_1.__extends(EffectFogChunk, _super);
    /**
     * Creates a new EffectEnvMapChunk.
     */
    function EffectFogChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     * @inheritDoc
     */
    EffectFogChunk.prototype._initVO = function (chunkVO) {
        chunkVO.needsProjection = true;
    };
    /**
     * @inheritDoc
     */
    EffectFogChunk.prototype._activate = function () {
        if (this._invalid) {
            var data = this._shader.fragmentConstantData;
            var index = this._fogColorIndex;
            var color = this._method.fogColor;
            data[index] = ((color >> 16) & 0xff) / 0xff;
            data[index + 1] = ((color >> 8) & 0xff) / 0xff;
            data[index + 2] = (color & 0xff) / 0xff;
            data[index + 3] = 1;
            data[index + 4] = this._method.minDistance;
            data[index + 5] = 1 / (this._method.maxDistance - this._method.minDistance);
            data[index + 6] = 0;
            data[index + 7] = 0;
        }
    };
    /**
     * @inheritDoc
     */
    EffectFogChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var fogColor = registerCache.getFreeFragmentConstant();
        var fogData = registerCache.getFreeFragmentConstant();
        var temp = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp, 1);
        var temp2 = registerCache.getFreeFragmentVectorTemp();
        var code = "";
        this._fogColorIndex = fogColor.index * 4;
        code += "sub " + temp2 + ".w, " + sharedRegisters.projectionFragment + ".z, " + fogData + ".x\n" +
            "mul " + temp2 + ".w, " + temp2 + ".w, " + fogData + ".y\n" +
            "sat " + temp2 + ".w, " + temp2 + ".w\n" +
            "sub " + temp + ", " + fogColor + ", " + targetReg + "\n" +
            "mul " + temp + ", " + temp + ", " + temp2 + ".w\n" +
            "add " + targetReg + ", " + targetReg + ", " + temp + "\n"; // fogRatio*(fogColor- col) + col
        registerCache.removeFragmentTempUsage(temp);
        return code;
    };
    return EffectFogChunk;
}(ShaderChunkBase));
export { EffectFogChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/EffectFogChunk.js